import { useSuspenseManagedLighthouses } from '#api/managed-lighthouses.queries.ts';

/**
 * Whether the given network is covered by a managed lighthouse (MTLH): it has an entry in
 * GET /v1/managed-lighthouses, from the shared org-wide fetch. The endpoint lists one entry per
 * network with an active tenancy — opted-out networks, ineligible v1 networks, and disabled
 * tenancies are simply absent, so entry presence IS coverage. A pending entry counts —
 * provisioning is transient and self-resolving, so warnings shouldn't treat it as a gap. The
 * delete/block dialogs use this to soften the "last lighthouse/relay" warning — managed
 * lighthouses keep the network connected and relaying, so removing the last self-hosted one isn't
 * the disruption it would otherwise be.
 */
export function useIsManagedLighthouseCovered(networkId: string) {
  const managedLighthouses = useSuspenseManagedLighthouses();
  return managedLighthouses.some((lighthouse) => lighthouse.networkID === networkId);
}
